module.exports = "/packs/dinners-club-497a228127ca1e89ae2334e406d948da.png";